import styled from "styled-components";
import { color } from "../../res/color";

export const ContentBox = styled.section<any>`
  padding: 24px;
  background-color: ${color.WHITE};
  border-radius: 8px;
  margin: auto;
  width: ${(p) => (p.notfull ? "700px" : "100%")};
  max-width: 100vw;

  @media (max-width: 750px) {
    width: 100%;
    padding: 24px 16px;
  }
`;

export const SubBox = styled.div`
  padding-bottom: 24px;
`;
